export const RETURN_TO_LIBRARY = 'library';
export const RETURN_TO_BUILDER = 'builder';

const CONTEXT_KEYS = ['return_to', 'course', 'library_id', 'search', 'type', 'status', 'category_id', 'tag_id'] as const;

export function libraryContextSearchParams(searchParams: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams();
  for (const key of CONTEXT_KEYS) {
    const value = searchParams.get(key);
    if (value) next.set(key, value);
  }
  return next;
}

export function libraryBackUrl(searchParams: URLSearchParams): string {
  const returnTo = searchParams.get('return_to');
  const courseId = searchParams.get('course');

  if (returnTo === RETURN_TO_BUILDER && courseId) {
    const query = libraryContextSearchParams(searchParams);
    query.delete('return_to');
    query.delete('course');
    const qs = query.toString();
    return `/courses/${courseId}/builder${qs ? `?${qs}` : ''}`;
  }

  const query = libraryContextSearchParams(searchParams);
  query.delete('return_to');
  query.delete('course');
  const qs = query.toString();
  return `/library${qs ? `?${qs}` : ''}`;
}

export function libraryFromCourseBuilder(searchParams: URLSearchParams): boolean {
  return (
    searchParams.get('return_to') === RETURN_TO_BUILDER && Boolean(searchParams.get('course'))
  );
}

export function libraryBackLabel(searchParams: URLSearchParams): string {
  if (searchParams.get('return_to') === RETURN_TO_BUILDER && searchParams.get('course')) {
    return 'Volver al curso';
  }
  return 'Volver a biblioteca';
}

export function libraryShowUrl(objectId: string, searchParams: URLSearchParams): string {
  const query = libraryContextSearchParams(searchParams);
  const qs = query.toString();
  return `/library/${objectId}${qs ? `?${qs}` : ''}`;
}

export function libraryPreviewUrl(objectId: string, searchParams: URLSearchParams): string {
  const query = libraryContextSearchParams(searchParams);
  const qs = query.toString();
  return `/library/${objectId}/preview${qs ? `?${qs}` : ''}`;
}

export function libraryCreateUrl(searchParams: URLSearchParams): string {
  const query = libraryContextSearchParams(searchParams);
  const qs = query.toString();
  return `/library/create${qs ? `?${qs}` : ''}`;
}

export function libraryEditUrl(objectId: string, searchParams: URLSearchParams): string {
  const query = libraryContextSearchParams(searchParams);
  const qs = query.toString();
  return `/library/${objectId}/edit${qs ? `?${qs}` : ''}`;
}

export function libraryShowQueryFromCourseBuilder(courseId: string): URLSearchParams {
  const params = new URLSearchParams();
  params.set('return_to', RETURN_TO_BUILDER);
  params.set('course', courseId);
  return params;
}

export function withLibraryContext(path: string, searchParams: URLSearchParams): string {
  const qs = libraryContextSearchParams(searchParams).toString();
  return qs ? `${path}?${qs}` : path;
}

export function libraryCrossEntryHref(path: string, libraryId: string, searchParams: URLSearchParams): string {
  const query = libraryContextSearchParams(searchParams);
  query.set('return_to', RETURN_TO_LIBRARY);
  query.set('library_id', libraryId);
  return `${path}?${query.toString()}`;
}

export function libraryOriginBack(
  searchParams: URLSearchParams,
  fallbackTo: string,
  fallbackLabel: string,
): { to: string; label: string } {
  if (searchParams.get('return_to') !== RETURN_TO_LIBRARY) {
    return { to: fallbackTo, label: fallbackLabel };
  }
  const libraryId = searchParams.get('library_id');
  if (!libraryId) return { to: fallbackTo, label: fallbackLabel };

  const query = libraryContextSearchParams(searchParams);
  query.delete('library_id');
  if (query.get('course')) {
    query.set('return_to', RETURN_TO_BUILDER);
  } else {
    query.delete('return_to');
    query.delete('course');
  }
  const qs = query.toString();
  return {
    to: `/library/${libraryId}${qs ? `?${qs}` : ''}`,
    label: 'Volver al objeto de biblioteca',
  };
}
